import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router';

import { orgNotificationSettingsAtom } from '@/features/NotificationSettings/NotificationSettings.store';

import type { NotificationSettingsAlertDialogProps } from './NotificationSettingsAlertDialog.types';

const NotificationSettingsAlertDialog = (
  props: NotificationSettingsAlertDialogProps
) => {
  const { open, setOpen } = props;
  const [orgNotificationSettings] = useAtom(orgNotificationSettingsAtom);
  const navigate = useNavigate();

  return (
    <Dialog
      fullWidth
      onClose={() => {
        setOpen(false);
      }}
      open={open}
      maxWidth="md"
    >
      <DialogTitle>Organization Notification Settings Issues</DialogTitle>
      {/* TODO: fix zero padding issue */}
      <DialogContent sx={{ p: 2, pt: '1rem!important' }}>
        The following issues have been identified with the organization&#39;s
        notification settings:
        <ul>
          {!orgNotificationSettings.announcement && (
            <li>
              No members of the organization are receiving announcement
              notifications.
            </li>
          )}
          {!orgNotificationSettings.ticket_service && (
            <li>
              No members of the organization are receiving service ticket
              notifications.
            </li>
          )}
          {!orgNotificationSettings.ticket_threat && (
            <li>
              No members of the organization are receiving threat ticket
              notifications.
            </li>
          )}
          {!orgNotificationSettings.priority_1 && (
            <li>
              No members of the organization are receiving P1 threat ticket
              notifications.
            </li>
          )}
          {!orgNotificationSettings.priority_2 && (
            <li>
              No members of the organization are receiving P2 threat ticket
              notifications.
            </li>
          )}
          {!orgNotificationSettings.priority_3 && (
            <li>
              No members of the organization are receiving P3 threat ticket
              notifications.
            </li>
          )}
          {!orgNotificationSettings.priority_4 && (
            <li>
              No members of the organization are receiving P4 threat ticket
              notifications.
            </li>
          )}
          {!orgNotificationSettings.priority_5 && (
            <li>
              No members of the organization are receiving P5 threat ticket
              notifications.
            </li>
          )}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            navigate('/administration/users');
            setOpen(false);
          }}
        >
          Go to Organization User&#39;s Page
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationSettingsAlertDialog;
